import APIClient from '../../../../common/services/APIClient';
import { setForceUpdate } from '../../../../common/components/SSPList/actions';
import { toggleChargerDetailsFetching } from '../../actions';

export const FW_UPDATE_ERROR_CODES = {
  offline_update_queued: 121,
  factoryMode: 120,
};

const setError = (text) => ({
  type: 'SET_ERROR',
  text,
});

const toggleFetch = (flag) => ({
  type: 'TOGGLE_FETCH',
  flag,
});

export const resetData = () => ({
  type: 'FIRMWARE_RESET_DATA',
});

const setFiles = (files) => ({
  type: 'SET_FILES',
  files,
});

export const loadUpdateFiles = () => (dispatch) => {
  dispatch(resetData());
  dispatch(toggleFetch(true));
  APIClient.get('/firmwares/available')
    .then(({ data }) => {
      dispatch(toggleFetch(false));
      dispatch(setFiles(data));
    })
    .catch(() => {
      dispatch(toggleFetch(false));
      dispatch(setError('Error while loading list of files'));
    });
};

export const toggleErrorSnackbar = (flag) => ({
  type: 'TOGGLE_ERROR_SNACKBAR',
  flag,
});

export const toggleSnackBar = (flag) => ({
  type: 'FIRMWARE_UPDATE_TOGGLE_SNACKBAR',
  flag,
});

export const toggleFirmwareUpdateModal = (open) => ({
  type: 'TOGGLE_FIRMWARE_UPDATE_MODAL',
  open,
});

export const firmwareUpdateWithFile = (file, uuid, online) => (dispatch) => {
  dispatch(toggleFirmwareUpdateModal(false));
  dispatch(toggleChargerDetailsFetching(true));
  dispatch(setError(null));
  const payload = {
    firmware_version_uuid: file.uuid,
    force_update: file.force_update,
  };

  APIClient.put(`/chargers/${uuid}/control/update_firmware`, payload)
    .then(() => {
      dispatch(toggleChargerDetailsFetching(false));
      dispatch(setForceUpdate('activitiesList'));
      if (online) {
        dispatch(toggleSnackBar(true));
      } else {
        dispatch(setError(`Command to update FW to ${file.firmwareVersionName} was queued.`));
        dispatch(toggleErrorSnackbar(true));
      }
    })
    .catch(({ response: { data: { code, message } } }) => {
      dispatch(toggleFetch(false));
      if (code && message) {
        if (code !== FW_UPDATE_ERROR_CODES.offline_update_queued) {
          if (message.includes('No response received') || message.includes('Timeout error.')) {
            message = 'Device didn\'t respond. Please try again.';
          } else if (message.includes('Internal error') || message.match(/Cannot ((un)?subscribe|publish)/g) || message.includes('Error occurred')) {
            message = 'Internal error occurred. Please see Charger Activities for more details.';
          } else if (code === FW_UPDATE_ERROR_CODES.factoryMode) {
            message = 'Update is not send as device is in factory mode.';
          }
        }
      } else {
        message = 'Error while making firmware update.';
      }
      dispatch(toggleChargerDetailsFetching(false));
      dispatch(setError(message));
      dispatch(toggleErrorSnackbar(true));
      dispatch(setForceUpdate('activitiesList'));
    });
};

export const clear = () => ({
  type: 'FIRMWARE_CLEAR_STATE',
});

export const selectFile = (id) => ({
  type: 'SELECT_FILE',
  id,
});
export const setForceFWUpdate = (forceUpdate) => ({
  type: 'SET_FORCE_UPDATE',
  forceUpdate,
});
